import { useState, useEffect } from "react";
import ListUpcomingAppointments from "./Lists/ListUpcomingAppointments/ListUpcomingAppointments";
import { format, parseISO, isAfter } from "date-fns";
import { useContext } from "react";
import { AuthContext } from "../../../../shared/context/auth-context";
import { Button } from "@mui/material";
function UpcomingAppointmentsTratamentoComponent({
  clienteId,
  sendRequest,
  dadosProximosAgendamentos,
}) {
  const [upcommingAppointments, setUpcommingAppointments] = useState([]);
  const [mostrarTodos, setMostrarTodos] = useState(false);

  const auth = useContext(AuthContext);

  useEffect(() => {
    const fetchProximosAgendamentos = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/agendatratamento/${
            mostrarTodos ? "todos" : "proximosagendamentos"
          }/${clienteId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );

        const responseData2 = await sendRequest(
          `${
            process.env.REACT_APP_BACKEND_LINK
          }/api/agendamentostratamentoemtransicao/${
            mostrarTodos ? "todos" : "proximosagendamentos"
          }/${clienteId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );

        const responseDataTratamentoIsolados = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoIsolados/${
            mostrarTodos ? "todos" : "proximosagendamentos"
          }/${clienteId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );

        const responseDataAgendamentosProvisorios = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/agendamentosprovisorio/proximosagendamentos/${clienteId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );

        let tempAppointments = [];

        responseData.marcacoes.forEach((mr) => {
          tempAppointments.push({
            data: format(parseISO(mr.data_inicio_execucao), "dd-MM-yy"),
            horaInicio: format(parseISO(mr.data_inicio_execucao), "HH:mm"),
            horaFim: format(parseISO(mr.data_fim_execucao), "HH:mm"),
            data_completa: mr.data_inicio_execucao,
            tratamento: mr.avaliacao ? "Avaliação" : mr.tratamento.designacao,
            medico: { id: mr.medico._id, nome: mr.medico.name },
            agendadoPor: mr.agendadoPor ? mr.agendadoPor?.name : "",
            tipo: mr.avaliacao ? "" : "Procedimento",
            faltou: mr.faltou,
            atendido: mr.atendido,
            atendimentoNaoExecutado: mr.atendimentoNaoExecutado,
            /* Onde é a consulta. Numa clínica com duas unidades, esta lista
               juntava as das duas sem dizer qual era qual — e é dela que sai
               o papel que o doente leva para casa. */
            estabelecimento: mr.estabelecimento,
          });
        });

        responseData2.marcacoes.forEach((mr) => {
          tempAppointments.push({
            data: format(parseISO(mr.data_inicio_execucao), "dd-MM-yy"),
            horaInicio: format(parseISO(mr.data_inicio_execucao), "HH:mm"),
            horaFim: format(parseISO(mr.data_fim_execucao), "HH:mm"),
            data_completa: mr.data_inicio_execucao,
            tratamento: mr.tratamento.designacao,
            medico: { id: mr.medico._id, nome: mr.medico.name },
            agendadoPor: mr.agendadoPor ? mr.agendadoPor?.name : "",
            tipo: "Transição",
            faltou: mr.faltou,
            atendido: mr.atendido,
            atendimentoNaoExecutado: mr.atendimentoNaoExecutado,
            estabelecimento: mr.estabelecimento,
          });
        });

        responseDataTratamentoIsolados.marcacoes.forEach((trIsl) => {
          tempAppointments.push({
            data: format(parseISO(trIsl.data_inicio_execucao), "dd-MM-yy"),
            horaInicio: format(parseISO(trIsl.data_inicio_execucao), "HH:mm"),
            horaFim: format(parseISO(trIsl.data_fim_execucao), "HH:mm"),
            data_completa: trIsl.data_inicio_execucao,
            tratamento: trIsl.tratamento.designacao,
            medico: {
              id: trIsl.medico._id,
              nome: trIsl.medico.name,
            },
            agendadoPor: trIsl.agendadoPor ? trIsl.agendadoPor?.name : "",
            tipo: "Tratamento Isolado",
            faltou: trIsl.faltou,
            atendido: trIsl.atendido,
            atendimentoNaoExecutado: trIsl.atendimentoNaoExecutado,
            estabelecimento: trIsl.estabelecimento,
          });
        });

        responseDataAgendamentosProvisorios.marcacoes.forEach((agProv) => {
          tempAppointments.push({
            data: format(parseISO(agProv.data_inicio_execucao), "dd-MM-yy"),
            horaInicio: format(parseISO(agProv.data_inicio_execucao), "HH:mm"),
            horaFim: format(parseISO(agProv.data_fim_execucao), "HH:mm"),
            data_completa: agProv.data_inicio_execucao,
            tratamento: agProv.tipo || "Limpeza",
            medico: {
              id: agProv.medico._id,
              nome: agProv.medico.name,
            },
            agendadoPor: agProv.agendadoPor ? agProv.agendadoPor?.name : "",
            tipo: "Agendamento Provisório",
            faltou: null,
            atendido: null,
            atendimentoNaoExecutado: null,
            estabelecimento: agProv.estabelecimento,
          });
        });

        tempAppointments = tempAppointments.sort((a, b) => {
          return new Date(a.data_completa) - new Date(b.data_completa);
        });

        setUpcommingAppointments(tempAppointments);
      } catch (err) {}
    };
    fetchProximosAgendamentos();
  }, [sendRequest, clienteId, auth, mostrarTodos]);

  const imprimirProximosAgendamentosHandler = () => {
    let tempAppointments = [];

    /* A unidade vai para o papel. É o papel que o doente leva: sem ela, ficava
       a saber a hora e não o sítio — e numa clínica com duas unidades isso
       manda-o para o lado errado da ilha. */
    const paraImprimir = (uA) => ({
      medico: uA.medico.nome,
      data: uA.data,
      horaInicio: uA.horaInicio,
      horaFim: uA.horaFim,
      data_completa: uA.data_completa,
      estabelecimento: uA.estabelecimento,
    });

    if (mostrarTodos) {
      const agora = new Date();
      upcommingAppointments.forEach((uA) => {
        if (isAfter(parseISO(uA.data_completa), agora)) {
          tempAppointments.push(paraImprimir(uA));
        }
      });
    } else {
      tempAppointments = upcommingAppointments.map(paraImprimir);
    }
    dadosProximosAgendamentos(tempAppointments);
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          className="checkbox-wrapper-51"
          id="planoTratamento__mostrar-terminados"
        >
          <input
            type="checkbox"
            id="mostrarTodos"
            onChange={() => setMostrarTodos((current) => !current)}
            checked={mostrarTodos}
          />
          <label htmlFor="mostrarTodos" className="toggle">
            <span>
              <svg width="10px" height="10px" viewBox="0 0 10 10">
                <path d="M5,1 L5,1 C2.790861,1 1,2.790861 1,5 L1,5 C1,7.209139 2.790861,9 5,9 L5,9 C7.209139,9 9,7.209139 9,5 L9,5 C9,2.790861 7.209139,1 5,1 L5,9 L5,1 Z"></path>
              </svg>
            </span>
          </label>

          <span className="checkbox-text">Mostrar todos agendamentos</span>
        </div>

        <Button
          variant="contained"
          color="primary"
          onClick={imprimirProximosAgendamentosHandler}
        >
          Imprimir Próximos Agendamentos
        </Button>
      </div>

      {upcommingAppointments.length !== 0 && (
        <>
          <ListUpcomingAppointments
            agendamentos={upcommingAppointments}
            mostrarTodos={mostrarTodos}
          />
        </>
      )}
      {upcommingAppointments.length === 0 && (
        <div className="no_data_div">
          {mostrarTodos
            ? "O Cliente não possui nenhum agendamento"
            : "Nenhum agendamento futuro!"}
        </div>
      )}
    </>
  );
}

export default UpcomingAppointmentsTratamentoComponent;
